import store from "./store";
export { STATES_MAIN, STATES_LANDING, STATES_START, STATES_TOUR, STATES_FIRST_VISIT } from "./states";
export default store;
